export default __webpack_public_path__ + "static/media/unavailable.fcb50747.svg";